import * as prismic from '@prismicio/client'

// Fill in your repository name
export const repositoryName = 'spajulyoganiko'

export const client = prismic.createClient(repositoryName, {
    accessToken: 'MC5acUIwTUJNQUFDSUFGS1lU.77-9bu-_ve-_ve-_vVtiBe-_ve-_ve-_vV9L77-977-977-977-977-9fe-_vUbvv73vv71n77-9Ye-_vWI177-977-977-9'
})